import * as convert from 'convert-units';

export const unitConverter = (dataUnit, targetUnit, value) => {
    
    if(dataUnit === targetUnit || !value) return value;
    
    const amount = typeof value === 'string' ? parseFloat(value) : value;

    const result = convert(amount).from(dataUnit.toLowerCase()).to(targetUnit.toLowerCase());

    return result;
}